var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_258_589)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.68413 1.68413C0 3.36827 0 6.07885 0 11.5V12.5C0 17.9212 0 20.6318 1.68413 22.3158C3.36827 24 6.07885 24 11.5 24H12.5C17.9212 24 20.6318 24 22.3158 22.3158C24 20.6318 24 17.9212 24 12.5V11.5C24 6.07885 24 3.36827 22.3158 1.68413C20.6318 0 17.9212 0 12.5 0H11.5C6.07885 0 3.36827 0 1.68413 1.68413ZM4.75005 7.5H6.50045C6.9478 7.5 7.1161 7.69575 7.28385 8.18035C8.13995 10.6736 9.5834 12.8525 10.1768 12.8525C10.3993 12.8525 10.5014 12.75 10.5014 12.185V9.6079C10.4612 8.87435 10.2049 8.5571 10.015 8.32215C9.8978 8.177 9.8059 8.0633 9.8059 7.90225C9.8059 7.7065 9.9732 7.5 10.2513 7.5H13.002C13.3729 7.5 13.5021 7.6983 13.5021 8.1433V11.6103C13.5021 11.981 13.6631 12.1108 13.7744 12.1108C13.9969 12.1108 14.1824 11.981 14.5904 11.5731C15.8513 10.1641 16.7414 7.9949 16.7414 7.9949C16.8527 7.7354 17.058 7.5 17.503 7.5H19.2534C19.7828 7.5 19.894 7.77245 19.7827 8.1433C19.5602 9.16295 17.4276 12.1664 17.4276 12.1664C17.2422 12.463 17.168 12.6114 17.4276 12.9451C17.5191 13.0731 17.7141 13.2641 17.9373 13.4827C18.1668 13.7075 18.4261 13.9614 18.633 14.2058C19.3849 15.0515 19.9515 15.765 20.1094 16.2567C20.2537 16.75 20.0036 17 19.5035 17H17.753C17.2842 17 17.0482 16.7374 16.538 16.1701C16.3218 15.9296 16.0563 15.6343 15.703 15.2811C14.6645 14.28 14.2194 14.1502 13.9598 14.1502C13.6075 14.1502 13.5021 14.25 13.5021 14.75V16.3194C13.5021 16.75 13.3644 17 12.2518 17C10.3973 17 8.35945 15.8744 6.913 13.7979C4.74333 10.7574 4.1499 8.45845 4.1499 7.9949C4.1499 7.7354 4.24993 7.5 4.75005 7.5Z",
    fill: "#C4CBD1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_258_589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.c7f42eca6a1a113da8353d8f0c93d520.svg";
export { ForwardRef as ReactComponent };